import { TemplateResult, html } from 'lit-html';
import { CookieConsentItem } from 'app/models/consent-data.model';

export function getMenuItemTemplate(data: CookieConsentItem): TemplateResult {
  return html`${data.name}`;
}
